export default "__VITE_ASSET__1379e205__"